export default "__VITE_ASSET__CQpBneYS__"